module.exports = __webpack_public_path__ + "assets/img/benefit-social.a80f0ba4.png";